export const dpohEntityConfig = {
    entityType: 'DPOHs',
    entityCatalogueConfig: {
        constants: {},
    },
    entityDashboardConfig: {
        constants: {},
        isSavePDFEnabled: false,
    },
};
